module.exports = __webpack_public_path__ + "img/1557040592.e6ac691d.jpg";